import { useContext } from "react";

import { PickersDay, PickersDayProps } from "@mui/x-date-pickers-pro";
import { DateTime } from "luxon";

import { DateTimePickerTextFieldContext } from "./DateTimePickerTextFieldContext";

export const DateTimePickerDay = ({ autoFocus, ...props }: PickersDayProps<DateTime>) => {
  const { isOpenedFromInput } = useContext(DateTimePickerTextFieldContext);

  return <PickersDay {...props} autoFocus={autoFocus && !isOpenedFromInput} />;
};
